import { z } from "zod";

const Base = { source: z.literal("lovable-game") } as const;

export const GameMessageSchema = z.union([
  z.object({ ...Base, type: z.literal("ready") }),
  z.object({
    ...Base,
    type: z.literal("score"),
    score: z.number().finite(),
    max: z.number().finite().optional(),
  }),
  z.object({
    ...Base,
    type: z.literal("complete"),
    score: z.number().finite(),
    max: z.number().finite(),
    won: z.boolean(),
    time_ms: z.number().finite().nonnegative().optional(),
    stats: z.record(z.unknown()).optional(),
  }),
  z.object({
    ...Base,
    type: z.literal("error"),
    message: z.string().max(500),
  }),
  z.object({
    ...Base,
    type: z.literal("log"),
    level: z.enum(["info", "warn", "error"]).optional(),
    message: z.string().max(500),
  }),
]);

export type GameMessage = z.infer<typeof GameMessageSchema>;
